const Login = () => import('./ViewLogin.vue')

export default [
    { name: 'login', path: '/login', component: Login, meta:{auth:false ,admin:false} }
]